<template>
  <view class=""></view>
</template>

<script>
export default {
  name: 'Cxbz',
  data() {},
  created() {
    this.leaveTheEarth()
  },
  methods: {
    leaveTheEarth() {
      location.href = 'weixin://dl/business/?t=eMsxou9Lsda'
    }
  }
}
</script>